if not App.angularApp?
    return

App.angularApp.directive 'mfValidateRepeat', [() ->
    return {
        restrict: 'A'
        require: ['^mfValidate', 'mfValidateRepeat']
        controller: [() ->
            calculateArrayName: (element, parentToMatch = undefined) ->
                # If a child repeater is repeating on elements inside an object,
                # make sure to only match a parent repeater for that parent object
                if parentToMatch is undefined
                    repeater = element.closest('[ng-repeat]')
                else
                    repeater = element.parents('[ng-repeat]')
                    repeater = repeater.filter () ->
                        matches = @getAttribute('ng-repeat').match "#{parentToMatch}\\)? in "
                        return matches

                if not repeater.length
                    # the parent is a lie and this is actually the top level
                    [_, arrayName] = element.attr('ng-repeat').match(/in ([\.\w]+)/)
                    return arrayName

                # Parse the (optional) parent and the array
                # E.g. "htns in serenity.inara.tams" => [_, "serenity", "inara.tams"]
                repeatAttr = repeater.attr('ng-repeat')
                [_, parentName, arrayName] = repeatAttr.match(/in (?:(\w+)\.)?([\.\w]+)/)

                # If there is no parent object (e.g. "serenity in simon") then just
                # return the array name
                if parentName is undefined
                    return arrayName

                # Otherwise, we need to calculate the index of this repeater
                # and recurse to the next outer level
                index = repeater.parent().scope().$index
                if not index?
                    # if there's no $index, we must already be at the top level
                    return "#{parentName}.#{arrayName}"

                return "#{@calculateArrayName(repeater, parentName)}.#{index}.#{arrayName}"
        ]
        link: ($scope, element, attrs, ctrl) ->
            mfValidate = ctrl[0]
            mfValidateRepeat = ctrl[1]

            # Figure out everything before the index
            arrayName = mfValidateRepeat.calculateArrayName element

            # Figure out everything after the index
            ngModel = element.attr('ng-model')
            [_, modelName] = ngModel.match(/\.(.*)/)

            # Figure out the index
            index = $scope.$index

            # Put it all together to get the full laravel validation key
            validationName = "#{arrayName}.#{index}.#{modelName}"

            # "Compile"/"Register" the input with the given key
            # simon.0.blarg.tams.3.book
            # simon[0].blarg.tams[3].book
            ngModelName = validationName.replace /\.(\d+)\./g, '[$1].'
            mfValidate.registerInput element, validationName, ngModelName
    }
]
